import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function Home() {
    const [comics, setComics] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/comics`)
            .then(res => {
                setComics(res.data.comics || res.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    if (loading) return <p className="container">Loading comics...</p>;

    return (
        <div className="container">
            <h1 style={{ marginTop: "20px" }}>Mrtoon</h1>

            {comics.length === 0 ? (
                <p>No comics available yet. Check back soon 📚</p>
            ) : (
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "20px"
                }}>
                    {comics.map(comic => (
                        <div
                            key={comic._id}
                            style={{
                                background: "var(--card-bg)",
                                color: "var(--card-text)",
                                padding: "15px",
                                borderRadius: "8px",
                                boxShadow: "var(--card-shadow)",
                                transition: "transform 0.2s"
                            }}
                        >
                            <h3 style={{ marginTop: 0 }}>{comic.title}</h3>
                            <p style={{ fontSize: "14px", opacity: 0.8 }}>
                                {comic.description}
                            </p>
                            <Link
                                to={`/comic/${comic._id}`}
                                style={{
                                    display: "inline-block",
                                    marginTop: "10px",
                                    color: "var(--primary-color)",
                                    fontWeight: "bold"
                                }}
                            >
                                Read →
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Home;
